import { render, staticRenderFns } from "./DetachCluster.vue?vue&type=template&id=e9e4245c&"
import script from "./DetachCluster.vue?vue&type=script&lang=js&"
export * from "./DetachCluster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports